<template lang="pug">
list-item-card.c-hand
  .pb-2(slot="header")
    .columns.pb-1
      .column
        span.abbr {{ cadastro | enums("cadastro.tipo") }}
        span.text-bold {{ cadastro.numero }}
      .column.col-auto.tooltip.tooltip-left(
        :data-tooltip="'cadastro.situacao' | tModel"
      )
        span.abbr {{ cadastro.situacao ? cadastro.situacao.descricao : "" }}
    .pt-1(v-if="cadastro.contribuinte") {{ cadastro.contribuinte.cpf_cnpj | cpfCnpj }} - {{ cadastro.contribuinte.razao_social }}
  .columns.align-center
    .column
      span.abbr.tooltip.tooltip-top(
        :data-tooltip="'cadastro.updated_at' | tModel"
      ) {{ cadastro.updated_at | date }}
    .column.col-auto
      router-link.btn.btn-link(
        :to="{ name: 'app.osm.consultas.cadastros.show', params: { id: cadastro.id } }"
      )
        btn-content(name="show")
</template>

<script>
export default {
  props: {
    cadastro: { type: Object, required: true },
  },
}
</script>
